import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'boxx-image-detail',
  templateUrl: './image-detail.component.html',
  styleUrls: ['./image-detail.component.scss'],
})
export class BoxxImageDetailComponent implements OnInit {
  @Input() image: string;
  @Input() nameImage: string;
  destroyed$ = new Subject<boolean>();
  translations: any;
  
  constructor(
    private modalCtrl: ModalController,
    translate: TranslateService
  ) {
    translate
      .get(['ACTIONS', 'IMAGES_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss();
  }

  ok() {
    this.modalCtrl.dismiss();
  }

}
